/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { Locale } from '@app/settings/locales/locales.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalesService } from '@app/settings/locales/locales.service';
import { Logger } from '@app/core';

const log = new Logger('localesFormComponent');

@Component({
  selector: 'app-locales-form',
  templateUrl: './locales-form.component.html',
  styleUrls: ['./locales-form.component.scss'],
})
export class LocalesFormComponent implements OnInit {
  @Input() locale: Locale = null;

  form: FormGroup;

  constructor(public modal: NgbActiveModal, private formBuilder: FormBuilder, private localeService: LocalesService) {}

  ngOnInit() {
    this.createForm();
  }

  save() {
    log.debug(this);
    if (this.locale && this.locale.id) {
      const locale: Locale = this.locale.deserialize(this.form.value);
      this.localeService.update(locale).subscribe((res) => this.modal.close(res));
    } else {
      const locale: Locale = new Locale().deserialize(this.form.value);
      this.localeService.store(locale).subscribe((res) => this.modal.close(res));
    }
  }

  private createForm() {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      locale: ['', [Validators.required]],
      active: [true],
    });

    if (this.locale) {
      this.form.patchValue(this.locale);
    }
  }
}
